import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

const VolunteerTable = ({ volunteers, onDelete, onEdit }) => {
  const [sortKey, setSortKey] = useState(null);
  const [sortAsc, setSortAsc] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortAsc(!sortAsc);
    } else {
      setSortKey(key);
      setSortAsc(true);
    }
  };

  const filtered = volunteers.filter((v) => {
    const haystack = (
      v.nume +
      " " +
      v.prenume +
      " " +
      v.email +
      " " +
      v.oras +
      " " +
      v.judet +
      " " +
      v.tara
    ).toLowerCase();
    return haystack.includes(searchTerm.toLowerCase());
  });

  const sorted = [...filtered].sort((a, b) => {
    if (!sortKey) return 0;
    const valA = a[sortKey]?.toLowerCase?.() ?? "";
    const valB = b[sortKey]?.toLowerCase?.() ?? "";
    if (valA < valB) return sortAsc ? -1 : 1;
    if (valA > valB) return sortAsc ? 1 : -1;
    return 0;
  });

  return (
    <div className="table-responsive neumorphic p-3 rounded">
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Caută după nume, email, oraș, județ sau țară..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th onClick={() => handleSort("prenume")} style={{ cursor: "pointer" }}>
              Prenume
            </th>
            <th onClick={() => handleSort("nume")} style={{ cursor: "pointer" }}>
              Nume
            </th>
            <th>Telefon</th>
            <th onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
              Email
            </th>
            <th>Oraș</th>
            <th onClick={() => handleSort("judet")} style={{ cursor: "pointer" }}>
              Județ
            </th>
            <th onClick={() => handleSort("tara")} style={{ cursor: "pointer" }}>
              Țara
            </th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((v) => (
            <tr key={v.id}>
              <td>{v.prenume}</td>
              <td>{v.nume}</td>
              <td>{v.telefon}</td>
              <td>{v.email}</td>
              <td>{v.oras}</td>
              <td>{v.judet}</td>
              <td>{v.tara}</td>
              <td>
                <Dropdown
                  onSelect={(action) => {
                    if (action === "edit") onEdit(v);
                    else if (action === "delete") onDelete(v.id);
                  }}
                >
                  <Dropdown.Toggle variant="secondary" size="sm">
                    Acțiuni
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="edit">Editează</Dropdown.Item>
                    <Dropdown.Item eventKey="delete" className="text-danger">
                      Șterge
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VolunteerTable;
